import { cn } from "@omni/utils/styles";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";

type InfoCardProps = {
    title: string;
    icon: string;
    iconAltText: string;
    description: string;
    link?: string;
    linkLabel: string;
};

const InfoCard = ({
    title,
    description,
    icon,
    iconAltText,
    link,
    linkLabel
}: InfoCardProps) => {
    return (
        <div
            className={cn(
                "tw:mb-2 tw:border tw:border-grey-light tw:border-solid tw:rounded-sm tw:p-4"
            )}
        >
            <div className={cn("tw:flex tw:flex-row tw:font-bold tw:mb-2")}>
                <div className={cn("tw:grow")}>{title}</div>
                <div className={cn("tw:flex tw:flex-row-reverse")}>
                    <div className={cn("tw:h-7.5")}>
                        <img
                            className={cn("tw:h-full")}
                            src={icon}
                            alt={iconAltText}
                        />
                    </div>
                </div>
            </div>
            <Row>
                <Col>
                    <div className={cn("tw:p-0 tw:m-0")}>
                        <p
                            className={cn("tw:pb-0 tw:mb-0")}
                            dangerouslySetInnerHTML={{ __html: description }}
                        ></p>
                        {!!link && (
                            <a
                                className={cn(
                                    "tw:py-2 tw:no-underline tw:text-information tw:hover:underline"
                                )}
                                href={link}
                            >
                                {linkLabel}
                            </a>
                        )}
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export { InfoCard };
